import { cn } from "../lib/cn";

// Logo nach CI: Bildmarke (Grafik aus brand/logo/) + Wortmarke "ortura" als
// echter Text in Manrope, Kleinbuchstaben (Entscheidung 32).
// tone="negativ" für dunkle Flächen (Navigation), "positiv" für helle.
// size="lg" für Einstiegsseiten (Login), "md" für Navigation und Kopfzeilen.
const sizes = {
  md: { gap: "gap-2", mark: "size-6", text: "text-lg" },
  lg: { gap: "gap-3", mark: "size-14", text: "text-5xl tracking-tight" },
} as const;

export function Wordmark({
  tone = "positiv",
  size = "md",
  className,
}: {
  tone?: "positiv" | "negativ";
  // keyof typeof sizes = "md" | "lg", direkt aus der Tabelle oben abgeleitet.
  size?: keyof typeof sizes;
  className?: string;
}) {
  const s = sizes[size];
  return (
    <span className={cn("inline-flex items-center", s.gap, className)}>
      <span
        aria-hidden="true"
        className={cn(
          "inline-block",
          s.mark,
          tone === "negativ" ? "ortura-bildmarke-negativ" : "ortura-bildmarke",
        )}
      />
      <span
        className={cn("font-semibold", s.text, tone === "negativ" ? "text-papier" : "text-nacht")}
      >
        ortura
      </span>
    </span>
  );
}
